/**
 * Compatibility shim — was Firebase, now delegates to Supabase adapters.
 * Components that import { auth, db, getCollectionName } from './firebase'
 * continue to work without modification.
 */
export { auth } from './auth-compat';
export { db } from './firestore-compat';

/**
 * Returns the collection name unchanged.
 * Firebase used the same collections in dev and prod; Supabase does the same.
 */
export const getCollectionName = (collectionName) => collectionName;

// Legacy re-exports kept so any file that does
//   import { firebaseConfig } from './firebase'
// doesn't break.
export const firebaseConfig = {};
